<template>
  <div class="m-activity-addCoupon">
    <div class="title">基本设置</div>
    <el-form v-if="isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="150px">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" class="input" />
      </el-form-item>
      <el-form-item label="活动时间" prop="activityDate">
        <el-date-picker
          v-model="form.activityDate"
          type="datetimerange"
          range-separator=""
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="入口场景" prop="entryScene">
        <el-radio-group  v-model="form.entryScene" @change="onEntryScene" :disabled="!!$route.query.id && $route.query.page !== 'copy' ">
          <el-radio v-for="item in entrySceneData" :key="item.name" :label="item.name">{{ item.desc }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="券渠道" prop="channel">
        <el-radio-group  v-model="form.channel" :disabled="!!$route.query.id && $route.query.page !== 'copy' " @change="onChannelChange" >
          <el-radio label="RT" :disabled="form.entryScene == 'Reduction' || form.entryScene == 'Distribution'">闰土自制</el-radio>
            <auth-button auth="market:coupon:center:read">
              <!-- <el-radio ref="VoucherCenter" label="VoucherCenter" :disabled="form.entryScene == 'ConsumptionCoupn'">券中台投放</el-radio> -->
            </auth-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="券类型" prop="couponKind">
        <el-radio-group  v-model="form.couponKind" :disabled="!!$route.query.id && $route.query.page !== 'copy'" @change="onProductTypeChange" v-if="form.channel != 'VoucherCenter'">
            <el-radio label="Coupon" v-if="form.entryScene == 'CouponCenter'">优惠券</el-radio>
            <el-radio label="LotCoupon" v-if="form.entryScene == 'CouponCenter'">停车券</el-radio>
            <el-radio label="GiftCoupon" v-if="form.entryScene == 'CouponCenter'">礼品券</el-radio>
            <auth-button auth="market:deductcoupon:template:read">
              <el-radio label="DeductCoupon" v-if="form.entryScene == 'ConsumptionCoupn' || form.entryScene == 'CouponCenter'">抵扣券</el-radio>
            </auth-button>
        </el-radio-group>
        <el-radio-group  v-model="form.couponKind" :disabled="!!$route.query.id && $route.query.page !== 'copy'" @change="onProductTypeChange" v-else>
          <el-radio label="CouponCenter">优惠券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择券" prop="couponTemplateId" v-if="form.channel=='RT'">
        <el-select v-model="form.couponTemplateId" placeholder="请选择券" @change="onCouponChange" collapse-tags :disabled="!!$route.query.id && $route.query.page !== 'copy' " filterable>
          <el-option v-for="item in couponSelectData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="选择券" prop="channelBizChild" v-if="form.channel=='VoucherCenter'">
        <el-cascader
            v-model="form.channelBizChild"
            placeholder="请选择券"
            :options="couponSelectData"
            :props="categoryCascaderProps"
            :disabled="!!$route.query.id && $route.query.page !== 'copy' && form.channel=='VoucherCenter'"
            clearable
            ref="category"
            @change="onCouponChange"
            filterable
          >
          </el-cascader>
      </el-form-item>
      <div class="coupon-table">
        <coupon-table :tableTrData="tableTrData" :couponType="form.couponKind"></coupon-table>
      </div>
       <el-form-item label="追加" prop="appendAmount" v-if="!!$route.query.id && $route.query.page !== 'copy'&&form.channel=='VoucherCenter'">
        <el-input v-model="form.appendAmount" placeholder="请输入追加数量" class="input" />
      </el-form-item>
      <div class="coupon-table"  v-if="!!$route.query.id && $route.query.page !== 'copy'&&form.channel=='VoucherCenter'&&voucherCenter_tableTrData.length!=0">
        <Table
          :tableThData="voucherCenter_tableThData"
          :tableTrData="voucherCenter_tableTrData"
          :pagination="false"
        >
          <template #updated="{ row }">{{ row.updated ? $moment(row.updated).format('YYYY/MM/DD HH:mm:ss') : '---'}}</template>
          <template #sort="{ row }">{{ row.sort }}</template>
          <template #amount="{ row }">{{ row.amount }}</template>
        </Table>
      </div>
      <el-form-item label="发放数量" prop="amount">
        <el-input v-model="form.amount" placeholder="请输入发放数量" oninput="value=value.replace(/[^\d]/g,'')" :disabled="!!$route.query.id && $route.query.page !== 'copy'&&form.channel!='RT'"/>
      </el-form-item>
      <el-form-item label="是否隐藏券" prop="hidden" v-if="form.couponKind != 'DeductCoupon'">
        <el-radio-group v-model="form.hidden" @change="onHiddenChange">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.hidden === false">
        <template v-if="form.entryScene == 'CouponCenter' && form.couponKind != 'DeductCoupon'">
          <el-form-item prop="deliveryChannel">
              <span slot="label">
                  <span class="span-box">
                    <span>是否同步首页</span>
                     <el-tooltip class="item" effect="dark" placement="bottom">
                        <div slot="content">
                          “是”表示该领券活动在领券中心及超值好券展示<br/>
                          “否”表示该领券活动只在领券中心展示<br/>
                        </div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                  </span>
                </span>
             <el-radio-group  v-model="form.deliveryChannel" @change="onDeliveryChannelChange">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="sort" v-if="form.deliveryChannel">
            <span slot="label">
                  <span class="span-box">
                    <span>渠道序号</span>
                     <el-tooltip class="item" effect="dark" placement="bottom">
                        <div slot="content">渠道序号排序规则只在超值好券有效，领券中心不生效</div>
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                  </span>
                </span>
             <el-input v-model="form.sort" placeholder="请输入渠道序号" oninput="value=value.replace(/^(0+)|[^\d]/g,'')">
            </el-input>
          </el-form-item>
        </template>
        <el-form-item prop="sorted">
          <span slot="label">
            <span class="span-box">
              <span>活动序号（选填）</span>
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <div slot="content">活动序号排序规则只在领券中心生效，超值好券不生效</div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
            </span>
           <el-input v-model="form.sorted" placeholder="请输入活动序号" oninput="value=value.replace(/^(0+)|[^\d]/g,'')">
          </el-input>
        </el-form-item>
      </template>
      <template v-if="showShareConfig && form.channel == 'VoucherCenter' && form.couponKind == 'CouponCenter'">
        <el-form-item label="领取方式" prop="shareType">
          <el-radio-group v-model="form.shareType">
            <el-radio label="Issue">仅领取券</el-radio>
            <el-radio label="Share">仅分享券</el-radio>
            <el-radio label="IssueAndShare">领取加分享</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="分享佣金" prop="commission">
          <el-input placeholder="请输入分享佣金" v-model="form.commission" oninput="value=value.replace(/[^.\d.]/g,'')" >
            <template slot="append">元</template>
          </el-input>
        </el-form-item> -->
         <auth-button auth="storedCard:mall:share:commission">
        <el-form-item label="分销佣金规则" prop="commissionType" >
          <el-radio-group v-model="form.commissionType" @change="commissionTypeChange">
            <el-radio label="None">不配置分销佣金</el-radio>
            <el-radio label="First">配置一级分拥</el-radio>
            <el-radio label="Second">配置二级分佣</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.commissionType == 'First' || form.commissionType == 'Second'" :style="form.commissionType == 'First' ?'margin-left: 280px;':'margin-left: 420px;'">
          <el-form-item label="用户分销佣金" prop="commission" label-width="120px">
            <el-input type="text" v-model="form.commission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('commission', form.commission)">
             <template slot="append">元/每张</template></el-input>
          </el-form-item>
        </div>
        <div v-if="form.commissionType == 'Second'" style="margin-left: 420px;">
          <el-form-item label="二级分销佣金" prop="secondaryCommission" label-width="120px">
            <el-input type="text" v-model="form.secondaryCommission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('secondaryCommission', form.secondaryCommission)">
             <template slot="append">元/每张</template></el-input>
          </el-form-item>
        </div>
        <div v-if="form.commissionType == 'Second'" style="margin-left: 540px;" class="commission-remark">注：二级分销佣金的受益人是分销用户的邀请人！</div>
        <el-form-item label="邀请人分佣规则" prop="inviterCommissionType" >
          <el-radio-group v-model="form.inviterCommissionType" @change="inviterCommissionTypeChange">
            <el-radio label="None">不配置邀请人佣金</el-radio>
            <el-radio label="First">配置邀请人佣金</el-radio>
          </el-radio-group>
        </el-form-item>
         <div v-if="form.inviterCommissionType == 'First'" style="margin-left: 280px;">
          <el-form-item label="邀请人佣金" prop="inviterCommission" label-width="120px">
            <el-input type="text" v-model="form.inviterCommission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('inviterCommission', form.inviterCommission)">
              <template slot="append">元/每张</template>
            </el-input>
          </el-form-item>
          </div>
          <div v-if="form.inviterCommissionType == 'First'" style="margin-left: 400px;" class="commission-remark">注：邀请人佣金的受益人是直接消费用户的邀请人！</div>
        </auth-button>
        <el-form-item label="分享appId" prop="issueAppId">
          <el-input placeholder="请输入分享appId" v-model="form.issueAppId" >
          </el-input>
        </el-form-item>
        <el-form-item label="分享小程序链接" prop="issueUrl">
          <el-input placeholder="请输入小程序链接" v-model="form.issueUrl" >
          </el-input>
        </el-form-item>
      </template>
      <el-form-item label="券每天总发限制" prop="dailyTotal">
        <el-radio-group v-model="form.dailyTotal" @change="limitRadioChange('dailyTotalLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>每天总限发</span>
            <el-form-item label="" prop="dailyTotalLimit">
              <el-input v-model="form.dailyTotalLimit" placeholder="请输入" :disabled="form.dailyTotal !== '2'" oninput="value=value.replace(/[^\d]/g,'')">
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="每日限领次数" prop="userDaily">
        <el-radio-group v-model="form.userDaily" @change="limitRadioChange('userDailyLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>每人每天限领</span>
            <el-form-item label="" prop="userDailyLimit">
              <el-input v-model="form.userDailyLimit" placeholder="请输入" :disabled="form.userDaily !== '2'" oninput="value=value.replace(/[^\d]/g,'')" >
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="用户总领限制" prop="userTotal">
        <el-radio-group v-model="form.userTotal" @change="limitRadioChange('userTotalLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>每人总限领</span>
            <el-form-item label="" prop="userTotalLimit">
              <el-input v-model="form.userTotalLimit" placeholder="请输入" :disabled="form.userTotal !== '2'" oninput="value=value.replace(/[^\d]/g,'')" >
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发放用户" prop="useRange">
        <el-radio-group v-model="form.useRange" :disabled="form.hidden">
          <el-radio label="AllUser">所有用户</el-radio>
          <!-- <auth-button auth="market:activity:portrait">
            <el-radio label="SpecifyUser">指定画像</el-radio>
          </auth-button> -->
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item v-if="form.useRange == 'SpecifyUser'" prop="portraitIds" label="" label-width="230px" >
        <el-select v-model="form.portraitIds" placeholder="请选择画像（最多可选3条）" filterable multiple collapse-tags :multiple-limit="3">
          <el-option v-for="item in portrayalData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="范围类型" prop="scopeType">
        <el-radio-group v-model="form.scopeType" :disabled="form.hidden">
          <el-radio label="AllMall">所有商场</el-radio>
          <el-radio label="Mall">指定商场</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.scopeType == 'Mall'" prop="mallIds" label="" label-width="230px" >
        <el-select v-model="form.mallIds" placeholder="请选择商场" filterable multiple collapse-tags>
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <detail v-else :form="form" :tableTrData="tableTrData" :filterMallData="filterMallData" :showShareConfig="showShareConfig"></detail>

    <div v-if="isEdit" class="button-box">
      <el-button @click="onCancel" class="mr20">取消</el-button>
      <el-button type="primary" @click="onNextStep" :loading="submitLoading">完成</el-button>
    </div>
    <div v-else-if="isCanEdit" class="button-box right">
      <auth-button auth="market:activity:update">
        <el-button type="primary" @click="onEdit" :loading="submitLoading">编辑</el-button>
      </auth-button>
    </div>

    <!-- 领取记录 -->
    <div class="winning-record" v-if="$route.query.page == 'detail'">
      <el-divider />
      <div class="title">领取记录</div>
      <get-coupon-record></get-coupon-record>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Table from "@/components/Table/index";
import GetCouponRecord from './components/getCouponRecord.vue'
import Detail from './components/detail.vue'
import couponTable from '../components/couponTable.vue'
import { api_getActivityBaseInfo, api_postAddCouponCenter, api_putUpdateCouponCenter, api_getCouponDetail,api_getGiftCouponDetail,api_getCouponTemplateList,api_getCouponTemplate, api_getActivityEntryScene,api_getDeductCouponSelect,api_getDeductCouponTemplate} from '@/api/market'
import { api_getListPortrait, api_getListCoupon,api_getGiftListCoupon, api_getConfig } from '@/api/common'
import { api_getParkingCouponTemplate,api_getParkingCouponDetail } from '@/api/parking'

export default {
  name: "marketActivityListAddCC",
  components: {
    AuthButton,
    Table,
    GetCouponRecord,
    Detail,
    couponTable
  },
  data() {
    // 校验张数限制
    const checkLimit = (rule, value, callback) => {
      const { field } = rule
      const radioField = field.split('Limit')[0]
      if (this.form[radioField] == '2' && !value) {
        callback(new Error('请输入'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的值'))
      } else {
        callback()
      }
    }
    // 校验分销
    const commission = (rule, value, callback) => {
      if (!(value + '')) {
        callback()
      }  else {
        callback()
      }
    }
    return {
      loadingID: null,
      submitLoading: false,
      isEdit: true, // 基本信息是否是编辑状态
      isCanEdit: true, // 活动是否可编辑
      form: {
        dailyTotal: '1',
        userDaily: '1',
        userTotal: '1',
        couponKind: 'Coupon',
        entryScene:'CouponCenter',
        channel:'RT',
        couponTemplateId:'',
        deliveryChannel:false,
        shareType: 'Issue',
        commission: '',
        inviterCommission:'',
        secondaryCommission:'',
        commissionType:'None',
        inviterCommissionType:'None',
      },
      categoryCascaderProps: {
        value: "id",
        label: "name",
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称' }],
        activityDate: [{ required: true, message: '请选择活动时间' }],
        entryScene: [{ required: true, message: '请选择入口场景' }],
        channel: [{ required: true, message: '请选择券渠道' }],
        couponKind: [{ required: true, message: '请选择券类型' }],
        couponTemplateId: [{required: true, message: '请选择优惠券'}],
        amount: [{required: true, message: '请输入发放数量'}],
        sort: [{ required: true, message: '请输入序号' }],
        shareType: [{ required: true, message: '请选择领取方式' }],
        useRange: [{required: true, message: '请选择发放用户'}],
        scopeType: [{required: true, message: '请选择范围类型'}],
        dailyTotal: [{required: true, message: '请选择'}],
        userDaily: [{required: true, message: '请选择'}],
        userTotal: [{required: true, message: '请选择'}],
        dailyTotalLimit: [{validator: checkLimit}],
        userDailyLimit: [{validator: checkLimit}],
        userTotalLimit: [{validator: checkLimit}],
        commission: [{ validator: commission }],
        inviterCommission: [{ validator: commission }],
        secondaryCommission: [{ validator: commission }],
      },
      voucherCenter_tableTrData:[], //券中台追加记录列表
      voucherCenter_tableThData:[
        { prop: "updated", label: "追加时间", minWidth: "200", },
        { prop: "sort", label: "追加次数", minWidth: "90", },
        { prop: "amount", label: "追加数量", minWidth: "120", },
      ],//券中台追加记录列表
      couponListData: [], // 优惠券list数据
      parkingListData: [], // 停车券list数据
      giftConponListData:[], // 礼品券list数据
      couponCenterListData:[], //券中台list数据
      deductCouponListData:[], // 抵扣券lis数据
      mallData: [], // 商场数据
      filterMallData: [],
      portrayalData: [], // 画像数据
      tableTrData: [],
      couponSelectData:[],
      entrySceneData: [], // 入口场景数据
      showShareConfig: false, // 分享配置
    };
  },
  async created() {
    this.loadingID = this.$baseLoading(6)
    await this.getCouponListData() // 获取优惠券列表数据
    await this.parkingCouponListData() // 获取停车券列表数据
    await this.getGiftCouponListData() // 获取礼品券券列表数据
    await this.getCouponCenterListData() // 获取券中台优惠券券列表数据
    await this.getDeductCouponListData() // 获取抵扣券列表数据
    this.form.type = this.$route.query.type
    this.getPortrayalData() // 获取画像数据
    this.getConfigData() // 获取config
    this.getEntryScene() // 入口场景数据

    if (this.$route.query.id) {
      this.getDetailData() // 获取详情数据
    }
    this.loadingID.close()
  },
  async mounted() {

  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.isEdit = false
      let res = await api_getActivityBaseInfo({id: this.$route.query.id})
      res.dailyTotal = res.dailyTotalLimit || res.dailyTotalLimit === 0 ? '2' : '1'
      res.userDaily = res.userDailyLimit || res.userDailyLimit === 0 ? '2' : '1'
      res.userTotal = res.userTotalLimit || res.userTotalLimit === 0 ? '2' : '1'
      res.deliveryChannel =  res.deliveryChannel=='First'?true:false
      res.couponKind = res.channel == 'VoucherCenter' ? 'CouponCenter' : res.couponKind
      res.appendRecord.map((item,index)=>{
          item.sort =  `第${index+1}次`
          return item
      })
      this.voucherCenter_tableTrData =  res.appendRecord
      console.log('基本信息res: ', res);
      let initDataKey = ['commission','inviterCommission','secondaryCommission']
      initDataKey.forEach((key)=>{
        res[key] ? '' : res[key] = ''
      })
      this.form = {
        ...res,
        activityDate: [res.startTime, res.endTime], // 活动时间
        scopeType: res.mallIds && res.mallIds.length ? 'Mall' : 'AllMall',
        channelBizChild:[res.channelBizChildRefId,res.channelBizRefId],
        channel:res.channel?res.channel:'RT',
        entryScene_data: this.entrySceneData.find(item => item.name == res.entryScene) || null
      }
      this.filterMallData = this.mallData.filter(item => this.form.mallIds.indexOf(item.id) >= 0)
      this.getCouponDetail(this.form.channel == 'VoucherCenter' ? this.form.channelBizChild[0] : this.form.couponTemplateId, this.form.couponKind) // 获取优惠券数据
      if (this.$route.query.page == 'copy') {
        this.isEdit = true
        this.form.activityDate = []
      } else if (res.status == 'Doing' || res.status == 'Ended') {
        this.isCanEdit = false // 已结束、进行中 状态不能编辑
      }
      this.returnFloat('commission', this.form.commission)
      this.returnFloat('inviterCommission', this.form.inviterCommission)
      this.returnFloat('secondaryCommission', this.form.secondaryCommission)
    },
    commissionTypeChange () {
      this.$refs['form'].clearValidate(['commission','secondaryCommission']);
      this.form.commission = this.form.secondaryCommission = ''
    },
    inviterCommissionTypeChange () {
      this.$refs['form'].clearValidate(['inviterCommission']);
      this.form.inviterCommission = ''
    },
    returnFloat(key, num) {
      if(num === '' || num === undefined){
        this.form[key] = ''
        return
      }
      num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
      if (num.indexOf(".") !== -1) {
        let [integerPart, decimalPart] = num.split(".");
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2);
        } else if (decimalPart.length === 1) {
          decimalPart += "0";
        }
        num = `${integerPart}.${decimalPart}`;
      } else {
        num += ".00";
      }
      this.form[key] = num;
    },
    // 获取config
    async getConfigData() {
      const {mall} = await api_getConfig(['mall'])
      this.mallData = mall // 商场
    },

    // 入口场景数据
    async getEntryScene() {
      const res = await api_getActivityEntryScene()
      this.entrySceneData = res.buttons || []
      this.showShareConfig = res.showShareText
    },

    // 获取闰土优惠券列表数据
    async getCouponListData() {
      const res = await api_getListCoupon()
      this.couponListData = res
      this.couponSelectData = this.couponListData
    },
    // 获取券中台优惠券列表数据
    async getCouponCenterListData() {
      return;
      let res = await api_getCouponTemplateList()
      res = res.map(item=>{
        item.id = item.refId
        item.children=item.vcPosts.map(form=>{
          form.id = form.refId
          form.name = `${form.name}-(${form.refId})`
          return form
        })
        return item
      })
      this.couponCenterListData = res
    },
    // 获停车券列表数据
    async parkingCouponListData() {
      const res = await api_getParkingCouponTemplate()
      this.parkingListData = res
    },

    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.giftConponListData = res
    },

    // 获取抵扣券列表数据
    async getDeductCouponListData() {
      const res = await api_getDeductCouponSelect()
      this.deductCouponListData = res
    },

    // 入口场景改变
    onEntryScene(value) {
      if (value == 'Reduction' || value == 'Distribution') {
        this.form.channel == 'RT' && (this.form.channel = '')
        if (this.$refs['VoucherCenter']) {
          this.form.channel = 'VoucherCenter'
          this.onChannelChange('VoucherCenter')
        }
      }
      if (value == 'ConsumptionCoupn' || value == 'CouponCenter') {
        this.form.channel = 'RT'
        this.onChannelChange('RT')
      }
    },

    // 券渠道改变
    onChannelChange(value) {
      if(value == 'VoucherCenter'){
        this.form.couponKind = 'CouponCenter'
        this.couponSelectData = this.couponCenterListData
      }else if(value == 'RT' && this.form.entryScene != 'ConsumptionCoupn'){
        this.form.couponKind = 'Coupon'
        this.couponSelectData = this.couponListData
      }else{
        this.form.couponKind = 'DeductCoupon'
        this.onProductTypeChange('DeductCoupon')
      }
      this.form.couponTemplateId = ''
      this.form.channelBizChild = ''
      setTimeout(()=>{
        this.$refs['form'].clearValidate(['couponTemplateId', 'channelBizChild']);
      },0)
      this.tableTrData = []
    },
    // 券类型改变
    onProductTypeChange(value) {
      this.form.couponTemplateId = ''
      setTimeout(()=>{
        this.$refs['form'].clearValidate(['couponTemplateId']);
      },0)
      this.tableTrData = []
      if (value === 'Coupon') {
        this.couponSelectData = this.couponListData
      } if (value === 'LotCoupon') {
        this.couponSelectData = this.parkingListData
      }
      if (value === 'GiftCoupon') {
        this.couponSelectData = this.giftConponListData
      }
      if (value === 'DeductCoupon') {
        this.couponSelectData = this.deductCouponListData
      }
    },

    // 券下拉框改变
    onCouponChange(value) {
      if(this.form.channel=='RT'){
        const curCoupon = this.couponSelectData.filter(item => item.id == value)
        this.tableTrData = curCoupon
      }else{
        let curCoupon = this.couponSelectData.filter(item => (item.id == value[0]))
        curCoupon[0].children.map(item=>{
          if(item.id==value[1]){
            curCoupon[0].remain = item.stock
            console.log(curCoupon[0].remain)
            return item
          }
        })
        this.tableTrData = JSON.parse(JSON.stringify(curCoupon))
        this.$forceUpdate()
      }
    },
    // 获取券详情
    async getCouponDetail(couponTemplateId,type) {
      let res  = []
      switch (type) {
        case 'Coupon':
        res = await api_getCouponDetail({id: couponTemplateId})
         this.couponSelectData = this.couponListData
          break;
        case 'CouponCenter':
        console.log(couponTemplateId)
        res = await  api_getCouponTemplate({channelBizChildRefId: couponTemplateId,channelBizRefId:this.form.channelBizRefId})
        res.id = res.refId
        this.couponSelectData = this.couponCenterListData
          break;
        case 'LotCoupon':
        res = await api_getParkingCouponDetail({id: couponTemplateId})
        this.couponSelectData = this.parkingListData
          break;
        case 'GiftCoupon':
        res = await  api_getGiftCouponDetail({id: couponTemplateId})
        this.couponSelectData = this.giftConponListData
          break;
        case 'DeductCoupon':
          console.log(couponTemplateId)
        res = await  api_getDeductCouponTemplate({id: couponTemplateId})
        this.couponSelectData = this.deductCouponListData
          break;
          
        default:
          break;
      }
      this.tableTrData = res.id ? [res] : []
    },

    // 获取画像数据
    async getPortrayalData() {
      const res = await api_getListPortrait()
      this.portrayalData = res
    },

    // 限制 单选器改变
    limitRadioChange(name) {
      this.$refs.form.validateField(name)
      this.form[name] = null
      delete this.form[name]
    },

    // 是否隐藏券 改变事件
    onHiddenChange(value) {
      if (value) {
        // 是否是隐藏券为true时，发放用户、范围类型固定为所有用户和所有商场，并且不可编辑
        this.form = {
          ...this.form,
          deliveryChannel: false,
          sort: null,
          useRange: 'AllUser',
          scopeType: 'AllMall'
        }
      }
    },
    onDeliveryChannelChange(value){
        this.form = {
          ...this.form,
          sort: null,
        }
    },

    // 点击编辑按钮
    onEdit() {
      this.isEdit = true
    },

    // 点击提交基本信息
    onNextStep() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let { activityDate, scopeType, mallIds,deliveryChannel,channel,couponKind,channelBizChild } = this.form
            let params = {
              ...this.form,
              startTime: activityDate && activityDate[0] ? activityDate[0] : null,
              endTime: activityDate && activityDate[1] ? activityDate[1] : null,
              mallIds: scopeType == 'Mall' ? mallIds : [],
              deliveryChannel: deliveryChannel?'First':'GetCoupon',
              couponKind:channel=='VoucherCenter'?'Coupon':couponKind,
              channelBizChildRefId:channel=='VoucherCenter'?channelBizChild[0]:'',
              channelBizRefId:channel=='VoucherCenter'?channelBizChild[1]:''
            }

            delete params.scopeType
            delete params.activityDate // 删除活动时间原始数据
            delete params.dailyTotal
            delete params.userDaily
            delete params.userTotal
            if (this.$route.query.page == 'copy') {
              delete params.id
              delete params.status
              delete params.issued
            }
            !params.id && (params.disable = false) // 创建活动时默认状态

            console.log('params: ', params);

            let res = params.id ? await api_putUpdateCouponCenter(params) : await api_postAddCouponCenter(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.$router.push({
              query: {
                ...this.$route.query,
                id: res.id,
                page: 'detail'
              }
            })
            this.getDetailData()
            this.submitLoading = false
          } catch (err) {
            console.log('err: ', err);
            this.submitLoading = false
          }
        }
      })
    },

    // 图片上传事件
    getUploadFile (file, prizesItem) {
      prizesItem.iconKey = file
    },

    // 点击取消
    onCancel() {
      if (this.$route.query.id && this.$route.query.page === 'detail') {
        this.isEdit = false
      } else {
        this.$router.back(-1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-addCoupon {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  .commission-remark{
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }
  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .coupon-table {
    width: 80%;
    margin-left: 150px;
    margin-bottom: 20px;
  }
  .table-box {
    margin-top: 0;
  }

  .limit-pay-box {

  .el-radio__label {

    .el-form-item {
      display: inline-block;
      margin: 0;
      margin-left: 20px;
      .el-input {
        width: 190px !important;
      }
    }
  }
}

  .winning-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }
  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }

  .button-box{
    text-align: left;
    margin-top: 50px;

    &.right {
      text-align: right;
    }
  }
}
</style>
